import React from "react";
import FractionInput from "../../../../components/inputs/FractionInput";
import { InlineMath, BlockMath } from "react-katex";

// ==== GENERATOR ====

export function generateTask() {
  const a1 = Math.floor(Math.random() * 16 + 5) * 100; // 500–2000
  const q = Math.floor(Math.random() * 3) + 2;         // 2–4
  const n = Math.floor(Math.random() * 4) + 4;         // 4–7

  const total = Math.round(a1 * (1 - Math.pow(q, n)) / (1 - q));

  return {
    type: "FindViralReachTask",
    data: { a1, q, n, total }
  };
}

// ==== RENDER ====

export function renderTask(task) {
  const { a1, q, n } = task.data;

  return (
    <>
      <p>
        Post w mediach społecznościowych miał zasięg <InlineMath math={`${a1}`} /> osób pierwszego dnia.
        Codziennie jego zasięg rośnie <InlineMath math={`${q}`} />-krotnie.
      </p>
      <p>
        Ile osób łącznie zobaczyło post przez pierwsze <InlineMath math={`${n}`} /> dni?
      </p>
    </>
  );
}

export function renderInput(task, userAnswer, onChange, disabled) {
  return (
    <FractionInput
      placeholder="np. 14500"
      value={userAnswer}
      onChange={onChange}
      disabled={disabled}
    />
  );
}

export function checkAnswer(task, userAnswer) {
  const { total } = task.data;
  if (!userAnswer || typeof userAnswer !== "object" || userAnswer.parsed == null) return false;
  return Math.abs(userAnswer.parsed - total) < 0.01;
}

export function renderAnswer(task) {
  return <InlineMath math={`S = ${task.data.total}`} />;

}

export function renderExplanation(task) {
  const { a1, q, n, total } = task.data;
  const qn = Math.pow(q, n);
  const numerator = a1 * (1 - qn);
  const denominator = 1 - q;

  return (
    <div className="space-y-3" style={{ textAlign: "left" }}>
      <div><strong>Krok 1:</strong> Wzór na sumę zasięgów:</div>
      <BlockMath math={`S = a_1 \\cdot \\frac{1 - q^n}{1 - q}`} />

      <div><strong>Krok 2:</strong> Podstawiamy dane:</div>
      <BlockMath math={`S = ${a1} \\cdot \\frac{1 - ${q}^{${n}}}{1 - ${q}}`} />

      <div><strong>Krok 3:</strong> Obliczamy:</div>
      <BlockMath math={`S = ${a1} \\cdot \\frac{1 - ${qn}}{${denominator}}`} />
      <BlockMath math={`S = \\frac{${numerator}}{${denominator}}`} />
      <BlockMath math={`S = ${total}`} />
    </div>
  );
}

export function renderUserAnswer(userAnswer) {
  if (!userAnswer || typeof userAnswer !== "object" || !userAnswer.raw) {
    return <i>(brak odpowiedzi)</i>;
  }
  return <InlineMath math={`S = ${userAnswer.raw}`} />;
}
